<template>
 <div class="app-container">
   <div class="detailsTitle">
      <h4>客户管理</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
   </div>
  <customerManage :ZtenantCode="tenantCode" ></customerManage>
 </div>
</template>

<script>
import { getDictionary } from '@/api/soc-stock-cosco'
import customerManage from '@/views/newCrm/customerManage/index.vue'
export default {
  components: {
    customerManage
  },
  data () {
    let tenantCode = this.$route.query.code
    return {
      tenantCode: tenantCode
    }
  },
  created () {

  },
  mounted () {
  },
  methods: {
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style scoped lang='less'>

</style>
